import { React, useCallback, useState, useEffect,useRef } from "react";
import styled from "styled-components";
import { Button, Checkbox, Col, Form, Input, Menu, Row, Select } from "antd";
import {
  DownArrowDraw,
  HaberForm,
  FilteredGrid,
  FilterComp,
} from "../../../Pages/styledElements";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchIcon from "../../../Assets/Icons/search.svg";
import { DisabledButtonStyle } from "../../pageStyled";
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import { getCustomers } from "../../../Services/customerServices";
import {
  getAllGrades,
  getGradeQualities,
} from "../../../Services/settingsServices";
import { MultiSelect } from "react-multi-select-component";
import { getUnitData } from "../../../Services/measurementService";
import { weightUnit, lengthUnit } from "../../../Utils/Constant/MeasurementUnitList";
import { getMachineGradeSelectForConfig } from "../../../Services/settingsServices.js";

const { Option } = Select;

const MultiSelectHeader = styled.div`
  .dropdown-content {
    max-height: 100px;
  }
  .rmsc .options {
    max-height: 125px;
    color: #000 ;
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    line-height: 30px !important;
  }
  .rmsc .dropdown-heading .dropdown-heading-value {
    color: #000 ;
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    line-height: 30px !important;
    height : 35px;
  }
  .rmsc .dropdown-heading {
    height : 35px;
    }

  .rmsc .dropdown-container {
    background-color: var(--form-element-bg);
    border: 2px solid #dfe1e6;
    box-sizing: border-box;
    border-radius: 8px;
  }
`;

const SearchBarHeader = styled.div`
  .searchBoxWrap {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
  }
  .searchWidth {
    width: 38%;
    .ant-row {
      margin: 0;
    }
    .ant-col {
      input[type="text"] {
        padding-left: 15px !important;
      }
    }
    .searchIcon {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 2;
        right: 10px;
        top: 12px;
        width: 22px;
        height: 17px;
        background-image: url(${SearchIcon});
      }
    }
  }
  .exportDataBtn {
    align-self: center;
    button {
      &:last-child {
        margin-right: 0px;
      }
      svg {
        top: 3px;
      }
    }
  }
  .themeBtn {
    margin: 0px 6px !important;
  }
  .filterParent {
    display: flex;
    position: relative;
    margin-right: auto;
    margin-left: 30px;

    .filterBtn {
      min-width: 90px;
      border: none;
      background-color: transparent;
      text-align: center;
      align-self: center;
      outline: none;
      svg {
        position: relative;
        top: 2px;
      }
      span {
        font-size: 15px;
        font-family: var(--sf-pro-display-m);
        color: #605e5c;
        padding-left: 7px;
      }
    }
  }
`;

const ApproveOrderHeader = ({
  placeholder,
  setShow,
  show,
  fetchOrder,
  exportRole,
  exportTrigger,
  clearSearch,
  setClearSearch,
  filterOptions,
  applyFilter,
  setCurrentPage,
  setPaginationParams,
  unitType
}) => {
  const selectedGsmOptions = useRef('equal_to');
  
  const [filterType, setFilterType] = useState();
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [gsmFilterType, setGsmFilterType] = useState('equal_to');
  const [appliedFiltersArray, setAppliedFiltersArray] = useState();
  const [checkAllStates, setCheckAllStates] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectedStates, setSelectedStates] = useState([]);
  const [dateSelectionRange, setDateSelectionRange] = useState({
    startDate: new Date(),
    endDate: null,
    key: "selection",
  });
  const [filterBtnDisable, setFilterBtnDisable] = useState(false);
  const [grades, setGrades] = useState([]);
  const [searchedGrades, setSearchedGrades] = useState([]);
  const [qualities, setQualities] = useState([]);
  const [searchedQualities, setSearchedQualties] = useState([]);
  const [showQualities, setShowQualities] = useState(false);
  const [selectedGrade, setSelectedGrade] = useState();
  const [selectedQualities, setSelectedQualities] = useState([]);
  const [checkAllQualities, setCheckAllQualities] = useState(false);
  const [qualityIndeterminate, setQualityIndeterminate] = useState(false);
  const [selectedGradeQualities, setSelectedGradeQualtites] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [multiSelectSearch, setMultiSelectSearch] = useState({
    bool: false,
    searchedOptions: [],
  });
  const [disableFilter, setDisableFilter] = useState(true);
  const [unitData,setUnitData] = useState();
  const [form] = Form.useForm();
  const [filterForm] = Form.useForm();
  const [sizeFilterForm] = Form.useForm();
  const [orderTypesData, setOrderTypesData] = useState();

  const gsmFilterOptions = [
    { label: "Equal to", value: "equal_to" },
    { label: "Less than", value: "less_than" },
    { label: "Greater than", value: "greater_than" },
    { label: "In Range", value: "in_range" },
  ];

  const sizeTypeOptions = [
    { label: "Width", value: "width" },
    { label: "Length", value: "length" },
    { label: "Both", value: "both" },
  ];

  const multiSelectEnum = {
    order_type: { options: [
      { value: "Reel", label: "Reel" },
      { value: "Sheet", label: "Sheet" },
    ], },
    customer: { options: customers },
    consignee: { options: customers },
  };
  const [selectedOption, setSelectedOption] = useState([]);
  const filterRef = useRef();

  const handleClickOutside = (e) => {
    if (
      e.target.innerText !== "Equal to" &&
      e.target.innerText !== "Less than" &&
      e.target.innerText !== "Greater than" &&
      e.target.innerText !== "In Range" &&
      e.target.innerText !== "Width" &&
      e.target.innerText !== "Length" &&
      e.target.innerText !== "Both" &&
      !(unitData?.units_management?.length.data.filter(( name ) => name === e.target.innerText).length) &&
      !(unitData?.units_management?.weight.data.filter(( name ) => name === e.target.innerText).length) &&
      !(unitData?.units_management?.currency.data.filter(( name ) => name === e.target.innerText).length) &&
      !filterRef?.current?.contains(e.target)
    ) {
      setShowFilterOptions(false);
      filterForm.resetFields();
      sizeFilterForm.resetFields();
      setGsmFilterType('equal_to');
      selectedGsmOptions.current = 'equal_to';
      setFilterType();
      setFilterBtnDisable(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  useEffect(() => {
    if (selectedGrade) {
      if (selectedQualities && selectedQualities.length && !checkAllQualities) {
        const newGradeFilter = {
          grade: selectedGrade,
          qualities: selectedQualities,
        };
        const tempObj = {
          type: "grade_quality",
          grades: [newGradeFilter],
        };
        setSelectedGradeQualtites(tempObj.grades);
        // console.log("obj", tempObj);
        setAppliedFiltersArray(tempObj);
        setDisableFilter(false);
      } else {
        if (checkAllQualities) {
          const newGradeFilter = {
            grade: selectedGrade,
            qualities: [],
          };
          const tempObj = {
            type: "grade_quality",
            grades: [newGradeFilter],
          };
          setSelectedGradeQualtites(tempObj.grades);
          // console.log("obj", tempObj);
          setAppliedFiltersArray(tempObj);
          setDisableFilter(false);
        }
        else {
          setDisableFilter(true);
        }
      }
    } else {
      setDisableFilter(true);
    }
  }, [selectedQualities]);

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(context, args);
      }, wait);
    };
  }
  const debounceOnChange = useCallback(debounce(fetchOrder, 1000), []);

  const filterSelect = (e) => {
    setFilterType(filterOptions[e.key]);
    setFilterBtnDisable(true);
    if (filterOptions[e.key]?.value !== "grade_quality") {
      closeFilterDropDown();
    } else {
      //setShowQualities(true)
    }
  };

  const showFilterDropDown = () => {
    setShowFilterOptions(!showFilterOptions);
  };

  const closeFilterDropDown = () => {
    setShowFilterOptions(false);
  };

  const closeFilterDetails = () => {
    filterForm.resetFields();
    sizeFilterForm.resetFields();
    // jobCardForm.resetFields();
    setGsmFilterType('equal_to');
    selectedGsmOptions.current = 'equal_to';
    setFilterType();
  };

  const backFilter = () => {
    setFilterType();
    setShowFilterOptions(true);
    setFilterBtnDisable(false);
    setDisableFilter(true);
  };

  const handleDateSelect = (ranges) => {
    console.log("Filter type in filter", filterType, ranges);
    setDateSelectionRange({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
      key: "selection",
    });
    const newFilter = {
      type: filterType.value,
      start_date: moment(ranges.selection.startDate).format("YYYY-MM-DD"),
      end_date: moment(ranges.selection.endDate).format("YYYY-MM-DD"),
    };
    if (dateSelectionRange.startDate && dateSelectionRange.endDate) {
      setDisableFilter(false);
    } else setDisableFilter(true);
    setAppliedFiltersArray(newFilter);
  };

  const openQualitiesHandler = (currentGrade) => {
    setSelectedGrade(currentGrade.name);
    // setShowQualities(true);
    getGradeQualities(currentGrade.name).then((resp) => {
      setQualities(resp.map((quality) => quality.name));
      setSearchedQualties(resp.map((quality) => quality.name));
      setShowQualities(true);
      if (resp.length === 0) {
        setDisableFilter(false);
      } else setDisableFilter(true);
    });
  };

  const searchGradeHandler = (e) => {
    if (e.target.value === "") {
      setSearchedGrades(grades);
    } else {
      setSearchedGrades(
        grades.filter((item) =>
          item.name.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
    }
  };

  const searchQualitiesHandler = (e) => {
    if (e.target.value === "") {
      setSearchedQualties(qualities);
    } else {
      setSearchedQualties(
        qualities.filter((item) =>
          item.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
    }
  };

  const searchMultiSelectHandler = (e) => {
    if (e.target.value === "") {
      setMultiSelectSearch({
        bool: false,
        searchedOptions: multiSelectEnum[filterType.value].options,
      });
      setSearchedQualties(qualities);
    } else {
      setSearchedQualties(
        qualities.filter((item) =>
          item.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
      setMultiSelectSearch({
        bool: true,
        searchedOptions: multiSelectEnum[filterType.value].options.filter(
          (item) => item.toLowerCase().includes(e.target.value.toLowerCase())
        ),
      });
    }
  };

  const selectAllHandler = (e) => {
    setCheckAllStates(!checkAllStates);
    setSelectedStates(
      e.target.checked ? multiSelectEnum[filterType.value].options : []
    );
    setIndeterminate(false);
  };

  const checkBoxOptionHandler = (e) => {
    setSelectedOption(e);
    if(e.length)
    {
      setDisableFilter(false);
    }
    else{
      setDisableFilter(true);
    }
    let updatedSelectedOption = [];
    for (let index = 0; index < e.length; index++) {
      const element = e[index];
      updatedSelectedOption.push(element.value);
    }
    setSelectedStates(updatedSelectedOption);
    setCheckAllStates(
      e.length === multiSelectEnum[filterType.value].options.length
    );
    setIndeterminate(
      e.length && e.length < multiSelectEnum[filterType.value].options.length
    );
  };

  const selectAllQualitiesHandler = (e) => {
    setCheckAllQualities(!checkAllQualities);
    // setSelectedQualities(e.target.checked ? qualities : []);
    setQualityIndeterminate(false);
    if (e.target.checked)
    {
      setDisableFilter(false);
      setSelectedQualities(qualities);
    }
    else {
      if (selectedQualities?.length)
        setDisableFilter(false);
      else
        setDisableFilter(true);
        setSelectedQualities([]);
    }
    
  };

  const checkQualityHandler = (e) => {
    setSelectedQualities(e);
    setCheckAllStates(e.length === qualities.length);
    setCheckAllQualities(e.length === qualities.length);
    setIndeterminate(e.length && e.length < qualities.length);
  };

  const applyFilterHandler = () => {
    setFilterBtnDisable(false);
    setDisableFilter(true);
    if (filterType.type === "inputSelect") {
      let minValue = parseFloat(filterForm.getFieldValue("gsmMin"));
      let maxValue = parseFloat(filterForm.getFieldValue("gsmMax"));
      let thresholdValue = parseFloat(
        filterForm.getFieldValue("gsmFilterValue")
      );

      switch (filterType.value) {
        case "gsm":
          const gsmFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_gsm: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_gsm: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { gsm: thresholdValue }),
          };
          applyFilter(gsmFilter);
          setAppliedFiltersArray(gsmFilter);
          break;
        case "burst_factor":
          const bfFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_burst_factor: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_burst_factor: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && {
              burst_factor: thresholdValue,
            }),
          };
          applyFilter(bfFilter);
          setAppliedFiltersArray(bfFilter);
          break;
        case "reel_od":
          const reel_odFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_reel_od: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_reel_od: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { reel_od: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_reel_od : filterForm.getFieldValue("unitSelect"),
            max_reel_od : filterForm.getFieldValue("unitSelect")} }),
              ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {reel_od : filterForm.getFieldValue("unitSelect")} }),
          };
          applyFilter(reel_odFilter);
          setAppliedFiltersArray(reel_odFilter);
          break;
        case "core_id":
          const core_idFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_core_id: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_core_id: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { core_id: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_core_id : filterForm.getFieldValue("unitSelect"),
            max_core_id : filterForm.getFieldValue("unitSelect")} }),
            ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {core_id : filterForm.getFieldValue("unitSelect")} }),
          };
          applyFilter(core_idFilter);
          setAppliedFiltersArray(core_idFilter);
          break;
      }
      closeFilterDetails();
      setShowFilterOptions(false);
      filterForm.resetFields();
      sizeFilterForm.resetFields();
      // jobCardForm.resetFields();
    } else if (filterType.type === "rangeTypeSelect") {
      let minValue = parseFloat(sizeFilterForm.getFieldValue("gsmMin"));
      let maxValue = parseFloat(sizeFilterForm.getFieldValue("gsmMax"));
      let thresholdValue = parseFloat(
        sizeFilterForm.getFieldValue("gsmFilterValue")
      );
      // let sizeType = sizeFilterForm.getFieldValue("sizeType");
      let sizeType;
      if(orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel"){
        sizeType = "width";
      } else{
        sizeType = sizeFilterForm.getFieldValue("sizeType");
      }
      // const sizeFilter = {
      //   type: filterType.value,
      //   operator:selectedGsmOptions.current,
//operator: gsmFilterType,
      //   size_type: sizeType,
      //   ...(selectedGsmOptions.current === "in_range" && { min_size: minValue }),
      //   ...(selectedGsmOptions.current === "in_range" && { max_size: maxValue }),
      //   ...(selectedGsmOptions.current !== "in_range" && { size: thresholdValue }),
      //   ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_size : sizeFilterForm.getFieldValue("unitSelect"),
      //   max_size : sizeFilterForm.getFieldValue("unitSelect")} }),
      //       ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {size : sizeFilterForm.getFieldValue("unitSelect")} }),
      // };
      const sizeFilter = {
            type: filterType.value,
            operator: (orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") ? gsmFilterOptions[0]?.value : gsmFilterType,
            size_type: sizeType,
            ...(selectedGsmOptions.current === "in_range" && { min_size: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_size: maxValue }),
            ...(((orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") || selectedGsmOptions.current !== "in_range") && { size: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_size : sizeFilterForm.getFieldValue("unitSelect"),
              max_size : sizeFilterForm.getFieldValue("unitSelect")} }),
            ...(filterType.unitType && ((orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") || selectedGsmOptions.current !== "in_range") && { units : {size : sizeFilterForm.getFieldValue("unitSelect")} }),
          };
      applyFilter(sizeFilter);
      setAppliedFiltersArray(sizeFilter);
      closeFilterDetails();
      setShowFilterOptions(false);
      filterForm.resetFields();
      sizeFilterForm.resetFields();
    } else {
      if (appliedFiltersArray) {
        applyFilter(appliedFiltersArray);
        closeFilterDetails();
        setShowFilterOptions(false);
        setSelectedGradeQualtites([]);
        setCheckAllQualities(false);
        setSelectedQualities([]);
        setIndeterminate(false);
        setSearchedGrades(grades);
        setSearchedQualties(qualities);
      }
    }
    setSelectedStates([]);
    setSelectedOption([]);
  };

  const onFieldsChange = (values, allValues) => {
    allValues.map((item) => {
      if (item.errors.length) {
        setDisableFilter(true);
        return;
      } else setDisableFilter(false);
    });
  };

  const clearFilters = () => {
    setIndeterminate(false);
    setSelectedStates([]);
    setAppliedFiltersArray([]);
    setSelectedGradeQualtites([]);
  };

  const clearHandler = () => {
    setFilterBtnDisable(false);
    closeFilterDetails();
    setShowFilterOptions(false);
    setDisableFilter(true);
    setQualities([]);
    setShowQualities(false);
    setSelectedGrade();
    setSelectedQualities([]);
    clearFilters();
    setAppliedFiltersArray();
    filterForm.resetFields();
    sizeFilterForm.resetFields();
    setSelectedGradeQualtites([]);
    setCheckAllQualities(false);
    setSelectedQualities([]);
    setIndeterminate(false);
  };

  const renderSwitch = (type) => {
    switch (type) {
      case "date":
        return (
          <div className="dateRanged">
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              Filter by Date Range
            </h6>
            <DateRangePicker
              ranges={[dateSelectionRange]}
              onChange={handleDateSelect}
            />
          </div>
        );
      case "grade":
        return (
          <div className="gradeFiltered scrolled-ui">
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              Filter by Grade
            </h6>
            <Input
              placeholder="Search Grade"
              className="searchFilt"
              onChange={searchGradeHandler}
            />
            <Menu
              selectedKeys={[]}
              //onClick={filterSelect}
            >
              {searchedGrades.map((item) => (
                <Menu.Item
                  onClick={() => openQualitiesHandler(item)}
                  key={item.key}
                >
                  {item.name} <span className="arrowSel"></span>
                </Menu.Item>
              ))}
            </Menu>
            <div
              className={`qualityDroped ${
                // showQualities && qualities?.length ? "qualityEnabled" : ""
                showQualities ? "qualityEnabled" : ""
              }`}
            >
              <div className="gradeFiltered scrolled-ui">
                <h6 className="filterTitle">Select Qualites</h6>
                <Input
                  placeholder="Search Quality"
                  className="searchFilt"
                  onChange={searchQualitiesHandler}
                />
                <Menu selectedKeys={[]}>
                  <HaberForm>
                    {qualities?.length ? (
                      <Form>
                        <div className="all-Qul">
                          <Form.Item
                            name=""
                            valuePropName=""
                            wrapperCol={{ span: 24 }}
                            className="alignedBox"
                          >
                            <Checkbox
                              indeterminate={qualityIndeterminate}
                              onChange={selectAllQualitiesHandler}
                              checked={checkAllQualities}
                            >
                              Select All products for this grade
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <label className="allQuality">
                          Select specific qualities
                        </label>
                        <div class="checkboxFilt">
                          <Checkbox.Group
                            options={searchedQualities}
                            value={selectedQualities}
                            onChange={checkQualityHandler}
                          />
                        </div>
                      </Form>
                    ) : (
                      <label
                        className="allQuality"
                        style={{ paddingTop: "12px" }}
                      >
                        No qualities for this grade
                      </label>
                    )}
                  </HaberForm>
                </Menu>
              </div>
            </div>
          </div>
        );
      case "inputSelect":
        return (
          <HaberForm className="filterForm filterRanged">
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              Filter by {filterType.value}
            </h6>
            <Form
              form={filterForm}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFieldsChange={onFieldsChange}
            >
              <Form.Item
                name="gsmFilterType"
                className=""
                rules={[
                  {
                    required: type === "inputSelect",
                    message: "This field is required",
                  },
                ]}
                                initialValue={gsmFilterOptions[0]?.value}

              >
                <Select
                  suffixIcon={<DownArrowDraw />}
                  onChange={(e) => {
                    console.log("Event", e);
                    setGsmFilterType(e);
                    selectedGsmOptions.current = e;
                  }}
                  className={filterType.value}
                  placeholder="Select Range"
                >
                  {gsmFilterOptions.map((item) => (
                    <Option key={item.value}>{item.label}</Option>
                  ))}
                </Select>
              </Form.Item>
              {selectedGsmOptions.current === "in_range" ? (
                <>
                <Row span={24} gutter={8}>
                  <Col span={12} className="d-flex" style={{height: filterType.unitType ? '40px' : ''}}>
                    <Form.Item
                      name="gsmMin"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "inputSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input
                        placeholder={`Min. ${filterType.value}`}
                        style={{ paddingLeft: "10px !important" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} className="d-flex" style={{height: filterType.unitType ? '40px' : ''}}>
                    <Form.Item
                      name="gsmMax"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "inputSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input
                        placeholder={`Max. ${filterType.value}`}
                        style={{ paddingLeft: "10px !important" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {filterType.unitType && ( <Row span={24} gutter={8}>
                <Col span={24} className="d-flex">
                <Form.Item
                name="unitSelect"
                className=""
                rules={[
                  {
                    required: type === "unitSelect",
                    message: "This field is required",
                  },
                ]}
              >
               <Select
                    suffixIcon={<DownArrowDraw />}
                    // onChange={(e) => {
                    //   console.log("Event", e);
                    //   setGsmFilterType(e);
                    // }}
                    className={filterType.value}
                    placeholder="Select Unit"
                  >
                    { filterType.unitType == 'length' ?  unitData.units_management.length.data.map((item) => (
                      <Option key={item}>{lengthUnit[item]?.displayName}</Option>
                    )) : filterType.unitType == 'weight' ? unitData.units_management.weight.data.map((item) => (
                      <Option key={item}>{weightUnit[item]?.displayName}</Option> )) : unitData.units_management.currency.data.map((item) => (
                        <Option key={item}>{item}</Option>))}
                  </Select>
              </Form.Item>
              </Col>
              </Row>)}
                </>
              ) : (
                <Row span={24} gutter={8}>
                  <Col span={filterType.unitType ? 12 : 24} className="d-flex">
                    <Form.Item
                      name="gsmFilterValue"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "inputSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input
                        placeholder={`Enter ${filterType.value}`}
                        style={{ paddingLeft: "10px !important" }}
                      />
                    </Form.Item>
                </Col>
                {filterType.unitType && ( <Col span={12} className="d-flex" >
                <Form.Item
                name="unitSelect"
                className=""
                rules={[
                  {
                    required: type === "unitSelect",
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                    suffixIcon={<DownArrowDraw />}
                    // onChange={(e) => {
                    //   console.log("Event", e);
                    //   setGsmFilterType(e);
                    // }}
                    className={filterType.value}
                    placeholder="Select Unit"
                  >
                    { filterType.unitType == 'length' ?  unitData.units_management.length.data.map((item) => (
                      <Option key={item}>{item}</Option>
                    )) : filterType.unitType == 'weight' ? unitData.units_management.weight.data.map((item) => (
                      <Option key={item}>{item}</Option> )) : unitData.units_management.currency.data.map((item) => (
                        <Option key={item}>{item}</Option>))}
                  </Select>
              </Form.Item>
                </Col>)}
                </Row>
              )}
            </Form>
          </HaberForm>
        );
        case "multiSelect":
          return (
            <HaberForm style={{ width: "100%" }}>
              <h6 className="filterTitle">
                <Button className="backfilter" onClick={backFilter}>
                  <span></span>
                </Button>{" "}
                {filterType.label}
              </h6>
              {/* <Input
                placeholder={`Search ${
                  filterType.label.split("by")[1] ||
                  filterType.label.spit("By")[1]
                }`}
                className="searchFilt"
                onChange={searchMultiSelectHandler}
              /> */}
              <Form>
                <div
                  className="filterSelectList checkboxFilt"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  {/* <Checkbox
                    indeterminate={indeterminate}
                    onChange={selectAllHandler}
                    checked={checkAllStates}
                  >
                    Select all
                  </Checkbox>
                  <Checkbox.Group
                    options={
                      multiSelectSearch.bool
                        ? multiSelectSearch.searchedOptions
                        : multiSelectEnum[filterType.value].options
                    }
                    value={selectedStates}
                    onChange={checkBoxOptionHandler}
                  /> */}
                   <MultiSelectHeader>
                    <MultiSelect
                      options={multiSelectEnum[filterType.value].options}
                      value={selectedOption}
                      onChange = { checkBoxOptionHandler}
                      valueRenderer={(selected) => {
                        if (!selected.length)
                          return `Search ${
                            filterType.label.split("by")[1] ||
                            filterType.label.spit("By")[1]
                          }`;
                      }}
                    />
                  </MultiSelectHeader>
                </div>
              </Form>
            </HaberForm>
          );
        case "rangeTypeSelect":
        return (
          <HaberForm className="filterForm filterRanged">
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              Filter by Size
            </h6>
            <Form
              form={sizeFilterForm}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFieldsChange={onFieldsChange}
            >
              <Form.Item
                name="gsmFilterType"
                className=""
                rules={[
                  {
                    required: type === "rangeTypeSelect",
                    message: "This field is required",
                  },
                ]}
                initialValue={gsmFilterOptions[0]?.value}
              >
                <Select
                  suffixIcon={<DownArrowDraw />}
                  onChange={(e) => {
                    console.log("Event", e);
                    setGsmFilterType(e);
                    selectedGsmOptions.current = e;

                  }}
                  placeholder="Select Range"
                  className={filterType.value}
                >
                  {gsmFilterOptions.map((item) => (
                    <Option key={item.value}>{item.label}</Option>
                  ))}
                </Select>
              </Form.Item>
              {!(orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") &&
              (<Form.Item
                name="sizeType"
                className="removepadd"
                rules={[
                  {
                    required: type === "rangeTypeSelect",
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                  suffixIcon={<DownArrowDraw />}
                  placeholder="Select size type"
                  // onChange={(e) => {
                  //   console.log("Event", e);
                  //   setGsmFilterType(e);
                  // }}
                >
                  {sizeTypeOptions.map((item) => (
                    <Option key={item.value}>{item.label}</Option>
                  ))}
                </Select>
              </Form.Item>)}
              {selectedGsmOptions.current === "in_range" ? (
                <Row span={24} gutter={8}>
                  <Col span={12} className="d-flex">
                    <Form.Item
                      name="gsmMin"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "rangeTypeSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input placeholder={`Min. ${filterType.value}`} />
                    </Form.Item>
                  </Col>
                  <Col span={12} className="d-flex">
                    <Form.Item
                      name="gsmMax"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "rangeTypeSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input placeholder={`Max. ${filterType.value}`} />
                    </Form.Item>
                  </Col>
                </Row>
              ) : (
                <Row span={24} gutter={8}>
                  <Col span={filterType.unitType ?  12 : 24} className="d-flex">
                    <Form.Item
                      name="gsmFilterValue"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "rangeTypeSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input placeholder={`Enter ${filterType.value}`} />
                    </Form.Item>
                    </Col>
                    {filterType.unitType && (<Col span={12} className="d-flex" >
                <Form.Item
                name="unitSelect"
                className=""
                rules={[
                  {
                    required: type === "unitSelect",
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                    suffixIcon={<DownArrowDraw />}
                    // onChange={(e) => {
                    //   console.log("Event", e);
                    //   setGsmFilterType(e);
                    // }}
                    className={filterType.value}
                    placeholder="Select Unit"
                  >
                    { filterType.unitType == 'length' ?  unitData.units_management.length.data.map((item) => (
                      <Option key={item}>{item}</Option>
                    )) : filterType.unitType == 'weight' ? unitData.units_management.weight.data.map((item) => (
                      <Option key={item}>{item}</Option> )) : unitData.units_management.currency.data.map((item) => (
                        <Option key={item}>{item}</Option>))}
                  </Select>
              </Form.Item>
              </Col>)}
                </Row>
              )}
            </Form>
          </HaberForm>
        );
      default:
        return <></>;
    }
  };

  useEffect(() => {
    ( async() => {
    await getUnitData().then((response) => {
      setUnitData(response.data);
      
    })
    .catch((error) => {
      console.log(error);
    });

    const resp = await getMachineGradeSelectForConfig();
          if (!resp.error) {
            let data = resp?.data?.data?.settings?.order_types;
            const filteredOrderTypes = data?.filter(item => item.value === true && (item.name === "reel" || item.name === "sheet"))
            .map(item => ({ name: item.name, value: item.value })); 
            setOrderTypesData(filteredOrderTypes);
        }
  })();
  }, []);

  useEffect(() => {
    getCustomers().then((resp) => {
      setCustomers(
        resp.map((item) => {
          return { value: item.name, label: item.name };
        })
      );
    });
  }, []);

  useEffect(() => {
    getAllGrades().then((resp) => {
      // console.log("Grades", resp);
      setSearchedGrades(resp);
      setGrades(resp);
    });
  }, []);

  useEffect(() => {
    if (clearSearch) {
      console.log("clear");
      form.resetFields();
      setClearSearch(false);
    }
  }, [clearSearch]);

  useEffect(() => { 
    if (selectedStates.length) {
      switch (filterType.value) {
        case "country":
          const countryFilter = {
            type: filterType.value,
            country: selectedStates,
          };
          setAppliedFiltersArray(countryFilter);
          break;
        case "status":
          const status =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Active"
              ? "active"
              : "disabled";
          const statusFilter = { type: filterType.value, status };
          setAppliedFiltersArray(statusFilter);
          break;
        case "shift":
          const shiftFilter = {
            type: filterType.value,
            shifts: selectedStates,
          };
          setAppliedFiltersArray(shiftFilter);
          break;
        case "statusOpen":
          const openClosedFilter = { type: "status", status: selectedStates };
          setAppliedFiltersArray(openClosedFilter);
          break;
        case "machine":
          const machineFilter = {
            type: filterType.value,
            machines: selectedStates,
          };
          setAppliedFiltersArray(machineFilter);
          break;
        case "order_type":
          const order_type =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Reel"
              ? "reel"
              : "sheet";
          const orderTypeFilter = { type: filterType.value, order_type };
          setAppliedFiltersArray(orderTypeFilter);
          break;
        case "orderStatus":
          const orderStatusFilter = {
            type: "status",
            status: selectedStates.map((item) =>
              item === "Open"
                ? "open"
                : item === "Pending"
                ? "pending"
                : item === "Changes Requested"
                ? "review"
                : item === "Approved"
                ? "approved"
                : item === "Rejected"
                ? "rejected"
                : item === "On Hold"
                ? "hold"
                : null
            ),
          };
          setAppliedFiltersArray(orderStatusFilter);
          break;
        case "customer":
          const customerFilter = {
            type: filterType.value,
            names: selectedStates,
          };
          setAppliedFiltersArray(customerFilter);
          break;
        case "consignee":
          const consigneFilter = {
            type: filterType.value,
            names: selectedStates,
          };
          setAppliedFiltersArray(consigneFilter);
          break;
        case "priority":
          const priority =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Yes"
              ? "yes"
              : "no";
          const priorityFilter = { type: filterType.value, priority: priority };
          setAppliedFiltersArray(priorityFilter);
          break;
        case "role":
          const role =
            selectedStates.length > 1
              ? "BOTH"
              : selectedStates[0] === "Basic"
              ? "BASIC"
              : "ADMIN";
          const roleFilter = { type: filterType.value, role };
          setAppliedFiltersArray(roleFilter);
          break;
      }
      setDisableFilter(false);
    } else setDisableFilter(true);
  }, [selectedStates]);

  return (
    <SearchBarHeader>
      <div className="searchBoxWrap">
        <HaberForm className="searchWidth">
          <Form
            form={form}
            name="basic"
            autoComplete="off"
            className="haberLogin"
          >
            <Form.Item
              name="username"
              className="searchIcon"
              rules={[{ required: "" }]}
            >
              <Input
                placeholder={placeholder}
                onChange={(e) => {
                  debounceOnChange(e.target.value);
                }}
              />
            </Form.Item>
          </Form>
        </HaberForm>
        
        {filterOptions && filterOptions?.length && (
          <div ref={filterRef} className="filterParent">
          <Button
              className="filterBtn "
              onClick={showFilterDropDown}
              disabled={filterBtnDisable}
            >
              <Iconmoon icon="filter" size={15} color="#605E5C" />
              Filter
            </Button>
            <div className="filterDropDown">
              <FilterComp
                visible={showFilterOptions}
                onCancel={closeFilterDropDown}
                className={`filterTypeSelect  ${
                  showFilterOptions ? "visibleTrue" : ""
                }`}
              >
                <FilteredGrid>
                  <div className="MainFiltered scrolled-ui">
                    <h6 className="filterTitle">Select Filter Type</h6>
                    <Menu selectedKeys={[]} onClick={filterSelect}>
                      {/* <Input placeholder="Filter Products" /> */}
                      {filterOptions.map((item) => (
                        <Menu.Item key={item.key}>{item.label}</Menu.Item>
                      ))}
                    </Menu>
                  </div>
                </FilteredGrid>
              </FilterComp>
              {filterType && (
                <FilterComp
                  visible={filterType}
                  className={`filterDetailsModal filterTypeSelect ${
                    filterType.value
                  } ${filterType ? "visibleTrue" : ""}`}
                  title={
                    <FilteredGrid>
                      <div className="filterHeader">
                        <button
                          className="filterBackBtn"
                          onClick={() => {
                            closeFilterDetails();
                            showFilterDropDown();
                          }}
                        >
                          B
                        </button>
                        {filterType.label}
                      </div>
                    </FilteredGrid>
                  }
                  onCancel={closeFilterDetails}
                >
                  {renderSwitch(filterType.type)}
                  <div className="ant-modal-footer-section filterBtmClick">
                    <Button
                      key="back"
                      className="themeBtn-plane"
                      onClick={clearHandler}
                    >
                      <Iconmoon icon="wrong" size={13} color="#ea655b" /> Clear
                    </Button>
                    <Button
                      key="submit"
                      className="themeBtn"
                      onClick={() => applyFilterHandler()}
                      disabled={disableFilter}
                    >
                      <Iconmoon icon="correct" size={13} color="#ffffff" />{" "}
                      Filter
                    </Button>
                  </div>
                </FilterComp>
              )}
            </div>
          </div>
        )}
        <div className="showPriorityOrder" style={{ display: "flex" }}>
          <DisabledButtonStyle>
            <Button
              className={
                // show
                //   ? "themeBtn noBg approveAllOrders"
                //   : "themeBtn noBg approve-header"
                "themeBtn noBg approve-header"
              }
              onClick={() => { setShow(!show); setCurrentPage(1); setPaginationParams({page:1,size:10})}}
            >
              <Iconmoon icon="filter" size={16} color="var(--theme-color)" />{" "}
              {show ? "Show All Orders" : "Show Priority Orders"}
            </Button>
          </DisabledButtonStyle>
        </div>
        {
          <div className="exportDataBtn">
            <Button onClick={exportTrigger} className="themeBtn noBg" disabled={!exportRole}>
              <Iconmoon icon="export" size={16} color="#ea655b" /> Export
            </Button>
          </div>
        }
      </div>
    </SearchBarHeader>
  );
};
export default ApproveOrderHeader;
